/**
 * Meta Pixel helper — fires standard & custom events.
 * The base pixel (PageView) is loaded in index.html.
 * These helpers fire additional events for key user actions.
 */

const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq(...args);
  }
};

/**
 * Fire a pixel event and return a Promise that resolves once the beacon
 * has likely been sent.  Uses `navigator.sendBeacon` awareness: the FB
 * pixel library dispatches an image request, so we give it a short
 * window (default 500 ms) before resolving.  This lets callers
 * `await` the pixel fire before doing a hard redirect.
 */
const fireAndWait = (method, eventName, data = {}, delayMs = 500) =>
  new Promise((resolve) => {
    fbq(method, eventName, data);
    setTimeout(resolve, delayMs);
  });

// Standard events
export const trackCompleteRegistration = (data = {}) =>
  fbq("track", "CompleteRegistration", data);

/** Awaitable version — use before redirects so the beacon actually sends */
export const trackCompleteRegistrationAsync = (data = {}) =>
  fireAndWait("track", "CompleteRegistration", data);

export const trackLead = (data = {}) => fbq("track", "Lead", data);

export const trackInitiateCheckout = (data = {}) =>
  fbq("track", "InitiateCheckout", data);

/** Awaitable version — use before redirects */
export const trackInitiateCheckoutAsync = (data = {}) =>
  fireAndWait("track", "InitiateCheckout", data);

export const trackPurchase = (data = {}) => fbq("track", "Purchase", data);

export const trackViewContent = (data = {}) =>
  fbq("track", "ViewContent", data);

export const trackSearch = (data = {}) => fbq("track", "Search", data);

export const trackContact = (data = {}) => fbq("track", "Contact", data);

// Custom events
export const trackCustom = (eventName, data = {}) =>
  fbq("trackCustom", eventName, data);
